import { ROUTES_INBOX } from "@accurx/inbox";
import { Switch } from "react-router-dom";
import { RedirectionPaths } from "routes/types";

import { SimpleRoute } from "app/AppRoute";
import { PostSsoRedirect } from "app/account/LogIn/PostSsoRedirect";
import { PostLoginRedirect } from "app/account/PostLoginRedirectComponent";
import {
    PATIENT_LISTS_ID_ROUTE,
    ROUTES,
    ROUTES_BASE,
    ROUTES_PRIMARY,
    ROUTES_WORKSPACE,
} from "shared/Routes";

export const PostAuthedRedirects = () => (
    <Switch>
        <SimpleRoute path={ROUTES.postlogin}>
            <PostLoginRedirect />
        </SimpleRoute>

        <SimpleRoute path={ROUTES.postSsoRedirect} exact>
            <PostSsoRedirect />
        </SimpleRoute>
    </Switch>
);

export const AUTHED_REDIRECTS: RedirectionPaths[] = [
    // Old Templates Pages
    // 10/03/2025 - 6,600 events in 60 days
    {
        from: "/message-templates",
        to: ROUTES_WORKSPACE.workspaceTemplatesOverview,
    },
    // Old Delivery Receipts
    // 10/03/2025 - 3,800 events in 60 days
    {
        from: "/delivery-receipts",
        to: ROUTES_WORKSPACE.workspaceDeliveryReceipts,
    },
    // Old Account Pages
    // 10/03/2025 - 2,750 events in 60 days
    {
        from: "/account/message-templates",
        to: ROUTES_WORKSPACE.workspaceTemplatesOverview,
    },
    // Old Workspace Pages
    // 10/03/2025 - 1,330 events in 60 days
    {
        from: "/workspace/personal-templates",
        to: ROUTES_WORKSPACE.workspaceTemplatesOverview,
    },
    // Old Patient Search Pages
    // 10/03/2025 - 3,000 events in 60 days
    {
        from: `/patients/search/clinician-conversation/:urlId`,
        to: `/w/:workspaceId/compose/search`,
        toParams: "?composeVariant=Clinician",
    },
    // Old Patient Search Pages
    // 10/03/2025 - 3,000 events in 60 days
    {
        from: `/patients/search/clinician-conversation`,
        to: `/w/:workspaceId/compose/search`,
        toParams: "?composeVariant=Clinician",
    },
    // Old Patient Search Pages
    // 10/03/2025 - 7,300 events in 60 days
    {
        from: `/patients/search/video-confirmation`,
        to: ROUTES_INBOX.MyInbox,
        toParams: "?patientSearch=true",
    },
    // Old Patient Search Pages
    // 10/03/2025 - 1,500 events in 60 days
    {
        from: `/patients/search/send-message`,
        to: `/w/:workspaceId/compose/search`,
    },
    // Old Patient Search Pages
    // 10/03/2025 - 26,000 events in 60 days
    {
        from: `/patients/search/patient-profile`,
        to: ROUTES_INBOX.MyInbox,
        toParams: "?patientSearch=true",
    },
    // Old Patient Search Pages
    // 10/03/2025 - 59,000 events in 60 days
    {
        from: "/search-for-patient",
        to: ROUTES_INBOX.MyInbox,
        toParams: "?patientSearch=true",
    },
    // Old Patient Search page
    // 10/03/2025 - 1,000,000 events in 60 days
    {
        from: ROUTES_BASE.patientsSearch,
        to: ROUTES_INBOX.MyInbox,
        toParams: "?patientSearch=true",
        exact: true,
    },
    // Old select product page
    // 10/03/2025 - 3,900 events in 60 days
    {
        from: "/select-product",
        to: ROUTES_INBOX.MyInbox,
        toParams: "?patientSearch=true",
    },
    // Old Patients page
    // 10/03/2025 - 400,000 events in 60 days
    {
        from: ROUTES_PRIMARY.patients,
        to: ROUTES_INBOX.MyInbox,
        exact: true,
    },
    // Get Started page
    // 10/03/2025 - 50,000 events in 60 days
    {
        from: ROUTES.get_started,
        to: ROUTES_INBOX.MyInbox,
        exact: true,
    },
    // Patient List Conversations page
    // 10/03/2025 - 238 events in 60 days
    {
        from: `${PATIENT_LISTS_ID_ROUTE}/w/:workspaceId/conversations/new`,
        to: ROUTES_INBOX.MyInbox,
        exact: true,
    },
    // Patient List Conversations page
    // 10/03/2025 - 360 events in 60 days
    {
        from: `${PATIENT_LISTS_ID_ROUTE}/w/:workspaceId/conversations/:conversationId`,
        to: ROUTES_INBOX.MyInbox,
        exact: true,
    },
    // Patient Search Conversations page
    // 10/03/2025 - 220 events in 60 days
    {
        from: `${ROUTES_BASE.patientsSearch}/w/:workspaceId/conversations/new`,
        to: ROUTES_INBOX.MyInbox,
        exact: true,
    },
    // Patient Search Conversations page
    // 10/03/2025 - 220 events in 60 days
    {
        from: `${ROUTES_BASE.patientsSearch}/w/:workspaceId/conversations/:conversationId`,
        to: ROUTES_INBOX.MyInbox,
        exact: true,
    },
];
